import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AddCategoryModel, UpdateCategoryModel } from '../models/category/addCategory.model';
import { CategoryListingModel } from '../models/category/categoryListing.modal';
import { ApiService } from './Common/api.service';
import { UrlHelperService } from './Common/urlhelper.service';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  constructor(private _api:ApiService) { }

  categorylisting(categorylist: CategoryListingModel){
    return this._api.post(UrlHelperService.categoryListing, categorylist)
  }

  leftCategoryMenu(){
    return this._api.post(UrlHelperService.addLeftCategoryMenu)
  }

  addCategory(addcategory: AddCategoryModel){
    return this._api.post(UrlHelperService.addCategory, addcategory)
  }
  
  getcategorybyid(id){
    return this._api.post(UrlHelperService.getcategorybyid+id);
  }

  getCategoryId = new BehaviorSubject(<string>'');
  passCategoryId(categoryId){
    this.getCategoryId.next(categoryId);
  }
  
  updateCategory(updateCategory: UpdateCategoryModel){
    return this._api.post(UrlHelperService.updateCategory+updateCategory.Id, updateCategory);
  }
}
